import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChange, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { NormasService } from '../_services/normas.service';
import { EmpresasService } from '../_services/empresas.service';
import { Norma } from '../_models/norma.model';

import { CuestionarioService } from "../_services/cuestionario.service";

declare var jQuery:any;

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";

import * as _ from "lodash";

@Component({
  selector: 'formularioevidenciastipocentro',
  templateUrl: 'formularioevidenciastipocentro.template.html',
  styleUrls: ['formularioevidenciastipocentro.template.css'],
  //providers:  [PreguntasService]
})
export class FormularioEvidenciasTipoCentrosComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() _id_tipocentro: any;

  @Input() puedoeditar: boolean;

  @Output() onChangeTipoCentro = new EventEmitter<boolean>();
  @Output() onCloseSeleccionarEvidencia = new EventEmitter<number>();
  @Output() onAnadirEvidencia = new EventEmitter<number>();

  subscription: Subscription;

  filtro: string = "";

  bloqueseleccionado: number = -1;

  id_tipocentro: any;

  etiqueta: string = "Seleccionar evidencias";

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  tipocentro: any = {};

  listabloques: any = [];


  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private empresasService: EmpresasService,
              private cuestionarioService: CuestionarioService,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

  }

  cerrarSeleccionarEvidencias(destino:number){
    this.cerrarVentana(destino);
  }

  cerrarVentana(destino:number){
    this.onCloseSeleccionarEvidencia.emit(destino);
  }

  actualizaPadre(){
    this.onChangeTipoCentro.emit(true);
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_id_tipocentro']){
      this.id_tipocentro = changes['_id_tipocentro'].currentValue;
    }

    if (this.id_tipocentro != 0){
      this.getTipoCentro(this.id_tipocentro);
      this.tipocentro.id_tipocentro = this.id_tipocentro;
    }


  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  onSubmit(){

    this.tipocentro.modulos = [];

    console.log(this.tipocentro);

    this.empresasService.setTipoCentro(this.tipocentro).subscribe(
      data => {
        if (data){
          console.log (data.json());

          let al: any = {
            "texto" : "Tipo de centro guardado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.actualizaPadre();

        }
      }
    );
  }

  getTipoCentro(id_tipocentro: number){
    this.empresasService.getTipoCentro(id_tipocentro).subscribe(
      data => {

        if (data){
          console.log(data.json().tipocentro);
          this.updateCampos(data.json().tipocentro);

          this.getMapaDocumentalCompleto();

        }

      }
    );
  }

  getMapaDocumentalCompleto(){
    this.empresasService.getMapaDocumentalCompleto().subscribe(
      data => {
        if (data){

          let aux = data.json().lista;
          this.listabloques = _.sortBy(aux,"descripcion");

          for (let blo of this.listabloques){
            for (let are of blo.areas){
              for (let mod of are.modulos){
                for (let evi of mod.evidencias){

                  if(evi.normativa.id_ambito){
                    let id_ambito = evi.normativa.id_ambito;
                    if (id_ambito == 1){
                      evi.abr = evi.abr + " [Nacional]";
                    }
                    if (id_ambito == 2){
                      evi.abr = evi.abr + " [Autonómico: "+evi.normativa.ambitoAutonomico+"]";
                    }
                    if (id_ambito == 7){
                      evi.abr = evi.abr + " [Internacional]";
                    }
                    if (id_ambito == 3){
                      evi.abr = evi.abr + " [Provincial: "+evi.normativa.ambitoProvincial+"]";
                    }
                    if (id_ambito == 6){
                      evi.abr = evi.abr + " [Local: "+evi.normativa.ambitoLocal+"]";
                    }
                  }


                }
              }
            }
          }

          console.log(this.listabloques);

        }
      }
    )
  }


  updateCampos(tipocentro: any){



  }

  showArea(i:any){
    jQuery("#area_"+i).show();
  }

  hideArea(){
    jQuery(".areawrap").hide();
  }

  showBloque(i:any){
    jQuery("#bloque_gen_"+i).show();
  }

  hideBloque(){
    jQuery(".bloque").hide();
    console.log(this.filtro);
  }

  verBloque(index: number){
    if (index != this.bloqueseleccionado){
      this.bloqueseleccionado = index;
    }else{
      this.bloqueseleccionado = -1;
    }
  }

  getAreas(areas: any){
    return _.sortBy(areas,"descripcion");
  }

  getModulos(modulos: any ){
    return _.sortBy(modulos,"descripcion");
  }

  getEvidencias(evidencias: any){
    return _.sortBy(evidencias,"abr");
  }

  verEvidencia(evidencia: any){
    console.log(evidencia);
  }

  anadirEvidencia(evidencia: any){
    console.log(this.id_tipocentro);
    console.log(evidencia);

    this.empresasService.setEvidenciaTipoCentro(this.id_tipocentro, evidencia.id_evidencia).subscribe(
      data => {
        if (data){
          this.onAnadirEvidencia.emit(evidencia.id_evidencia);
        }
      }
    )

  }

  anadirModulo(modulo: any){
    console.log(modulo);
  }

}



// WEBPACK FOOTER //
// ./src/app/tipocentros/formularioevidenciastipocentro.component.ts